export const codInternal = [
  { code: 400, msg: 'Datos inválidos' },
  { code: 401, msg: 'Error de acceso.' },
  { code: 403, msg: 'Error de permisos.' },
  { code: 404, msg: 'No se encontró el recurso.' },
  { code: 408, msg: 'Error de conexión.' },
  { code: 413, msg: 'Error de conexión.' },
  { code: 414, msg: 'Error de conexión.' },
  { code: 415, msg: 'Error de conexión.' },
  { code: 500, msg: 'Error en el servidor. Disculpe las molestias.' },
  { code: 501, msg: 'Error en el servidor. Disculpe las molestias.' },
  { code: 502, msg: 'Error en el servidor. Disculpe las molestias.' },
  { code: 503, msg: 'Error en el servidor. Disculpe las molestias.' },
  { code: 504, msg: 'Error en el servidor. Disculpe las molestias.' },
];
